import { render, staticRenderFns } from "./SideBarCategoryList.vue?vue&type=template&id=d17965dc&scoped=true&"
import script from "./SideBarCategoryList.vue?vue&type=script&lang=js&"
export * from "./SideBarCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17965dc",
  null
  
)

export default component.exports